// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__3hwgs","forms":"Login_forms__2lcj3"};